export default __webpack_public_path__ + "static/media/ktp-incorrect.69a90231.png";